import { useRecoilValue } from 'recoil';
import { useEffect, useState } from 'react';
import { measurementPeriodSelector } from '../../global-states';
import type { DataSheetFilterProjectBudgetCurrency } from '../../schema.graphql.ts';
import type { ProjectsFilterType } from './ProjectsFilter.tsx';

export type UseDefaultProjectsFilterOptions = {
    includeDatesFromLocalStorage?: boolean;
};
export type UseProjectsFilterOptions = UseDefaultProjectsFilterOptions;
export const emptyProjectsFilter: ProjectsFilterType = {
    metaResults: [],
    projects: [],
    projectCategories: [],
    sharedProjects: [],
    projectBudget: {
        currency: 'SEK' as DataSheetFilterProjectBudgetCurrency,
        from: null, // 0
        to: null, // Infinity
    },
    fromDate: null,
    toDate: null,
    surveyDateField: 'surveyDate',
};
export const useProjectsFilterState = (options?: UseProjectsFilterOptions) => {
    const projectsFilterState = useState(emptyProjectsFilter);
    const [, setFilter] = projectsFilterState;
    const { fromDate, toDate } = useRecoilValue(measurementPeriodSelector);

    useEffect(() => {
        if (options?.includeDatesFromLocalStorage) {
            setFilter((filter) => ({
                ...filter,
                fromDate,
                toDate,
            }));
        }
    }, [fromDate, toDate, options?.includeDatesFromLocalStorage, setFilter]);

    return projectsFilterState;
};
export const useDefaultProjectsFilter = (
    options?: UseDefaultProjectsFilterOptions,
): ProjectsFilterType => {
    const { fromDate, toDate } = useRecoilValue(measurementPeriodSelector);

    let filter = emptyProjectsFilter;
    if (options?.includeDatesFromLocalStorage) {
        filter = {
            ...filter,
            fromDate,
            toDate,
        };
    }

    return filter;
};
